const ProductData = [
  {
    id: 1,
    name: "Motherboard",
    description: "Main circuit board connecting all components.",
    price: 5499,
    image: "https://5.imimg.com/data5/RO/CT/MY-21956046/computer-motherboard-500x500.jpg",
  },
  {
    id: 2,
    name: "SMPS",
    description: "Power supply unit for stable voltage output.",
    price: 1299,
    image: "https://5.imimg.com/data5/FR/EH/MY-38302533/computer-smps.jpg",
  },
  {
    id: 3,
    name: "CPU Cooler",
    description: "Fan-based cooler for efficient CPU cooling.",
    price: 999,
    image: "https://elitehubs.com/cdn/shop/files/cl-p117-ca14bl-a_01_result.jpg?v=1705387843&width=533",
  },
  {
    id: 4,
    name: "Heat Sink",
    description: "Aluminum sink to dissipate processor heat.",
    price: 399,
    image: "https://static4.arrow.com/-/media/arrow/images/miscellaneous/h/heat-sink.png",
  },
  {
    id: 5,
    name: "CMOS Battery",
    description: "Battery for BIOS memory and system clock.",
    price: 99,
    image: "https://i.pinimg.com/564x/89/ec/97/89ec971c811b09bcf2be0911aee54e42.jpg",
  },
  {
    id: 6,
    name: "RAM",
    description: "Temporary memory for processing tasks.",
    price: 1399,
    image: "https://computerhardwarecomponentsandfunctions.wordpress.com/wp-content/uploads/2014/10/ram.jpg",
  },
  {
    id: 7,
    name: "ROM",
    description: "Permanent memory storing system firmware.",
    price: 499,
    image: "https://c8.alamy.com/comp/F227H7/chip-on-motherboard-mainboard-with-controllers-ports-and-wires-F227H7.jpg",
  },
  {
    id: 8,
    name: "Processor",
    description: "Brain of the computer for data processing.",
    price: 10499,
    image: "https://rukminim2.flixcart.com/image/850/1000/xif0q/processor/j/o/7/processor-core-i5-7500-suryaasys-original-imagrbn2ngupzjyc.jpeg?q=20&crop=false",
  },
  {
    id: 9,
    name: "Power Cable",
    description: "Supplies electricity to the components.",
    price: 199,
    image: "https://www.kei-ind.com/wp-content/uploads/2023/06/power-cables-and-their-various-types.jpg",
  },
  {
    id: 10,
    name: "NIC",
    description: "Network card for internet connectivity.",
    price: 599,
    image: "https://www.lifewire.com/thmb/3MUFuc6UqUvVYgjGk7zBpNakYXw=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/GettyImages-620725222-8ea61f13db054d0ba7ac7d06d0684443.jpg",
  },
  {
    id: 11,
    name: "SATA Cable",
    description: "Connects storage drives to the motherboard.",
    price: 149,
    image: "https://www.level1.com/media/catalog/product/cache/5dd1050e303ccd126a15d8279a1aa7f2/0/f/0f19f7afebd89093c52d26d51d5f6421a15a64bc_112054_v1_1.jpg",
  },
  {
    id: 12,
    name: "GPU",
    description: "Handles graphics rendering and acceleration.",
    price: 6999,
    image: "https://www.digitaltrends.com/wp-content/uploads/2022/01/nvidia-rtx-3050-review-2.jpg?fit=720%2C480&p=1",
  },
  {
    id: 13,
    name: "Thermal Paste",
    description: "Enhances heat transfer between CPU & cooler.",
    price: 99,
    image: "https://m.media-amazon.com/images/I/61ItDCoq14L.jpg",
  },
  {
    id: 14,
    name: "Cabinet (Case)",
    description: "Enclosure housing all hardware components.",
    price: 2499,
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgx0DI30SGvuoevW5p7THh9reLr_iDeCgyrg&s",
  },
  {
    id: 15,
    name: "BIOS Chip",
    description: "Stores firmware to boot the computer.",
    price: 299,
    image: "https://i.ebayimg.com/images/g/7tMAAOSwsNNeL3i~/s-l1200.jpg",
  },
];

export default ProductData;
